import { styled } from '@mui/material/styles';
import { COLOR } from '@src/styles/color';

export const StyledEducatorsHomeHeader = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  /* 65px = the sidebar's 64px logo block + its 1px Divider, so this header's
     bottom border lands on the same row as the sidebar's. box-sizing is
     border-box, so the content box is still 64px. */
  height: 65px;
  padding: 12px 24px;
  box-sizing: border-box;
  background-color: ${COLOR.white};
  border-bottom: 1px solid ${COLOR.indigo[16]};
  position: sticky;
  top: 0;
  z-index: 100;

  .header-title {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    flex: 1;
    min-width: 0;
  }

  .header-actions {
    display: flex;
    align-items: center;
    gap: 16px;
    flex-shrink: 0;
  }

  /* NewPackageInfoV3 relies on its parent for layout — each host container
     styles .wallet-package itself. */
  .wallet-package {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 2px;
    cursor: pointer;
  }

  @media only screen and (max-width: 768px) {
    padding: 12px 16px;
  }
`;
